// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__XzzR6","img":"styles_img__FTcuw"};